import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { Easings } from '@picsart/design-system/foundation/easings';

const useStyles = createUseStyles(
  {
    fullScreenOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: StackingContext.layout,
      backgroundColor: BackgroundColors.base,
      display: 'flex',
      flexDirection: 'column',
      animation: `$slideUp 0.3s ${Easings.easeOut}`,
    },
    '@keyframes slideUp': {
      from: {
        opacity: 0,
        transform: 'translateY(30px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    overlayHeader: {
      borderBottom: [1, 'solid', BackgroundColors.tint2],
      backgroundColor: BackgroundColors.base,
    },
    overlayContent: {
      flex: 1,
      overflow: 'hidden',
      backgroundColor: BackgroundColors.base,
    },
  },
  { name: 'resultOverlay' }
);

export default useStyles;
